import styled from 'styled-components';
import ErrorBoundary from '../../ErrorBoundary';
import Popover from '../../Popover';
import { ToolTip } from '../../../nav-ui-components/Tooltip';
import { useTranslation } from '../../../hooks/useNavConfig';
import useTimeoutFn from '../../../hooks/useTimeoutFn';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledDiv = styled.div.withConfig({
  displayName: "GlobalToolbarTooltip__StyledDiv",
  componentId: "sc-1jrrqmw-0"
})(["height:auto;display:flex;justify-content:center;align-items:center;"]);
export function GlobalToolbarTooltip({
  id: tooltipId,
  children,
  shouldRender,
  isOpen,
  placement,
  titleTextKey,
  textKey,
  closeButton,
  tooltipStyleOverrides,
  autoCloseTimeoutTime,
  onClose
}) {
  const {
    t
  } = useTranslation();
  const titleText = titleTextKey ? t(titleTextKey) : '';
  useTimeoutFn(onClose, autoCloseTimeoutTime);
  if (!shouldRender) {
    return null;
  }
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    boundaryName: "Global Toolbar - Tooltip",
    children: /*#__PURE__*/_jsx(Popover, {
      placement: placement,
      isOpen: isOpen,
      content: /*#__PURE__*/_jsx(ToolTip, {
        title: titleText,
        text: t(textKey),
        id: tooltipId,
        arrowPosition: "top",
        "aria-hidden": !isOpen,
        tooltipStyleOverrides: tooltipStyleOverrides,
        closeButton: closeButton
      }),
      children: /*#__PURE__*/_jsx(StyledDiv, {
        children: children
      })
    })
  });
}